import { render, staticRenderFns } from "./courseManage.vue?vue&type=template&id=05289286&"
import script from "./courseManage.vue?vue&type=script&lang=js&"
export * from "./courseManage.vue?vue&type=script&lang=js&"
import style0 from "./courseManage.vue?vue&type=style&index=0&id=05289286&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports